import fetchAPI from '../utils/fetchAPI';
import formatQueryString from '../utils/formatQueryString';

import { TFeedItem } from 'types/TFeeds';
import { TListingClient } from 'types/TListing';

type TGetFeedItemsProps = {
  itemId: TListingClient['itemId'];
  limit?: number;
};

export default async function getFeedItems(params: TGetFeedItemsProps): Promise<TFeedItem[]> {
  try {
    return await fetchAPI({
      url: `/v/api/feed-items?${formatQueryString(params)}`,
      preloadCompatible: true,
    });
  } catch {
    return [];
  }
}
